import React from 'react'
import { Grid, GridColumn, GridRow } from 'semantic-ui-react'
import Message from '../../common/Message'
import HealthQuestion from './HealthQuestion'
import { useSelector } from 'react-redux'
import useScrollToTop from '../../../hooks/useScrollToTop'
import { CI } from '../../../constant/HEALTH_INFORMATION_SEGMENTS'

export const INFO_MSG = 'The health information provided is used to underwrite your application for insurance. Please answer all questions as honestly and accurately as possible.'

export default function HealthInformation ({ path }) {

  const segment = useSelector(state => state.form.segments[path])
  const spsApplying = useSelector(state => state.form.segments.dependents.fields.spouseApplying)
  const chApplying = useSelector(state => state.form.segments.dependents.fields.childrenApplying)
  const applicantType = useSelector(state => state.form.options.applicantType)

  return useScrollToTop(segment && <>
    <Grid container divided='vertically'>
      <GridRow>
        <GridColumn width={8}>
          <h5>Underwriting Company</h5>
          <p>{segment.underwriting.company}</p>
        </GridColumn>
        <GridColumn width={8}>
          <h5>Home Office</h5>
          <p>{segment.underwriting.location}</p>
        </GridColumn>
        <GridColumn width={16} className='u-mY2'>
          <Message content={INFO_MSG} />
        </GridColumn>
      </GridRow>
      {Object.keys(segment.fields.healthQuestions)
        .filter(q => !segment.fields.healthQuestions[q].hide)
        .map(hq => <GridRow key={hq}>
          <HealthQuestion
            id={hq}
            healthQuestion={segment.fields.healthQuestions[hq]}
            rootPath={`segments.${path}.fields.healthQuestions.${hq}`}
            disableAdditionalInfo={segment.medicalConditionCount === segment.maxMedicalConditions}
            disableMedication={segment.medicationCount === segment.maxMedications}
            segmentPath={`segments.${path}`}
            applicants={[
              applicantType.value !== 'SP_ONLY' && {
                value: 'employee',
                label: 'Employee'
              },
              (spsApplying.value === 'yes' && !segment.fields.healthQuestions[hq].memberOnly) && {
                value: 'spouse',
                label: 'Spouse'
              },
              (path !== CI && segment.childrenIncluded && chApplying.value === 'yes' && !segment.fields.healthQuestions[hq].memberOnly) && {
                value: 'children',
                label: 'Each Child'
              }
            ].filter(Boolean)}
          />
        </GridRow>)}
      {Object.keys(segment.fields.healthInsuranceQuestions)
        .filter(q => !segment.fields.healthInsuranceQuestions[q].hide)
        .map(hiq => <GridRow key={hiq}>
          <HealthQuestion
            id={hiq}
            healthQuestion={segment.fields.healthInsuranceQuestions[hiq]}
            rootPath={`segments.${path}.fields.healthInsuranceQuestions.${hiq}`}
            applicants={[
              applicantType.value !== 'SP_ONLY' && { value: 'employee', label: 'Employee' },
              (spsApplying.value === 'yes' && !segment.fields.healthInsuranceQuestions[hiq].memberOnly) && {
                value: 'spouse',
                label: 'Spouse'
              },
              (path !== CI && segment.childrenIncluded && chApplying.value === 'yes' && !segment.fields.healthInsuranceQuestions[hiq].memberOnly) && { value: 'children', label: 'Child(ren)' }
            ].filter(Boolean)}
          />
        </GridRow>)}
    </Grid>
  </>)
}